import axios from 'axios'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Logo, { LogoType } from '../../components/atoms/Logo/Logo'
import ImageAsset, { ImageAssetType } from '../../components/atoms/ImageAsset/ImageAsset'
import { SELECT_PLAN } from '../../actions/authActions'
import './PaymentCheckoutPage.css'
import CommonFooter from '../../components/organisms/CommonFooter/CommonFooter'
import PlanCard from '../../components/molecules/PlanCard/PlanCard'
import { Plan } from '../../../commons/Plan'
import Button from '../../components/atoms/Button/Button'

class PaymentPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false
    }
  }

  async handleClickNext(paymentPlan) {
    try {
      this.setState({ isLoading: true })
      const res = await axios.post('/api/v1/organizers/projects/checkout', {
        plan: paymentPlan
      })
      location.href = res.data.url
    } catch (error) {
      if (error.response && error.response.status === 401) {
        alert('ログインしてください。')
        return
      }
      alert('エラーが発生しました。')
    } finally {
      this.setState({ isLoading: false })
    }
  }

  render() {
    const { selectPlan, paymentPlan } = this.props
    const showMorePlanCards = new URLSearchParams(window.location.search).get('plans') === 'more'

    return (
      <div styleName="background">
        <div styleName="container">
          <div styleName="backgroudImage">
            <ImageAsset type={ImageAssetType.TOP_VISUAL} />
          </div>
          <div styleName="mainContent">
            <div styleName="titlePart">
              <div styleName="logo">
                <Logo type={LogoType.GRAY} />
              </div>
              <h1 styleName="title">プランの選択</h1>
            </div>
            <React.Fragment>
              <div styleName="plan-card" onClick={() => selectPlan(Plan.LIGHT)}>
                <PlanCard plan={Plan.LIGHT} isSelected={paymentPlan === Plan.LIGHT} />
              </div>
              <div styleName="plan-card" onClick={() => selectPlan(Plan.SAFETY)}>
                <PlanCard plan={Plan.SAFETY} isSelected={paymentPlan === Plan.SAFETY} />
              </div>
              {showMorePlanCards && (
                <>
                  <div styleName="plan-card" onClick={() => selectPlan(Plan.PRO)}>
                    <PlanCard plan={Plan.PRO} isSelected={paymentPlan === Plan.PRO} />
                  </div>
                  <div styleName="plan-card" onClick={() => selectPlan(Plan.ENTERPRISE)}>
                    <PlanCard plan={Plan.ENTERPRISE} isSelected={paymentPlan === Plan.ENTERPRISE} />
                  </div>
                </>
              )}
              <div styleName="select-plan-button">
                <Button
                  isLoading={this.state.isLoading}
                  handleClick={() => this.handleClickNext(paymentPlan)}
                  isAccent
                  isEnabled={!!paymentPlan}
                >
                  <p>次へ</p>
                </Button>
              </div>
            </React.Fragment>
          </div>
        </div>
        <CommonFooter />
      </div>
    )
  }
}

PaymentPage.propTypes = {
  // state
  paymentPlan: PropTypes.number,
  // dispatch
  selectPlan: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  paymentPlan: state.auth.paymentPlan
})

const mapDispatchToProps = dispatch => ({
  selectPlan: plan => dispatch(SELECT_PLAN({ plan }))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentPage)
